module.exports = "/images/react-logo.png?eb6be414b75c412c13eeee2d2e8390cb";